export default __webpack_public_path__ + "static/media/Ravenkin Gloves.82a70205.jpg";